import { render, staticRenderFns } from "./form_index.vue?vue&type=template&id=59bdd138&scoped=true"
import script from "./form_index.vue?vue&type=script&lang=js"
export * from "./form_index.vue?vue&type=script&lang=js"
import style0 from "./form_index.vue?vue&type=style&index=0&id=59bdd138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bdd138",
  null
  
)

export default component.exports